import { defineMessages } from 'react-intl';

export default defineMessages({
    pageHeader: {
        id: 'adac.historyPage.Below you can find history of messages and documents sent out of and to the ADAC Portal.',
        defaultMessage: 'Below you can find history of messages and documents sent out of and to the ADAC Portal.'
    },
    backButton: {
        id: 'adac.historyPage.Go back',
        defaultMessage: 'Go back'
    }
});
